import { Pipe, PipeTransform } from '@angular/core';
import { SelectableItem } from '../models/selectable-item';

@Pipe({ name: 'itemPipe' })
export class ItemPipe implements PipeTransform {
  public transform(value: SelectableItem[]) {
    let filteredItems = []
    for (let index = 0; index < value.length; index++) {
      let filteredObj = this.levelTraverser(value[index]);
      filteredItems.push(filteredObj);
    }
    // console.log("filteredItems value ===> ",value)
    return filteredItems;
  }

  levelTraverser(items) {
      if (items.children && items.children.length) {
           items.children = items.children.filter((child) =>{
            if (child && child.children && child.children.length > 0 && child.matchFilter) {
                return this.levelTraverser(child)
            } else {
                // return (child.matchFilter || child._childSelected)
                return child.matchFilter
            }
          })
          return items;
      } else {
          if (items.matchFilter == true) {
            // if (items.matchFilter == true || items._childSelected == true) {
            return items
          } else {
              return []
          }

      }
  }

}
